<div class="modal-header">
  <h5 class="modal-title"><i class="fal fa-money-check-alt"></i> Create a Tax</h5>
  <button (click)="close()" type="button" class="close">
    <i class="fas fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="form" class="row">
    <div class="col-sm-5">
      <mat-form-field class="mat-block">
        <input type="text" formControlName="name" matInput required placeholder="Tax Name:" />
        <mat-error *ngIf="form.get('name').touched && form.get('name').hasError('required')">
          Tax name is <strong>required</strong>
        </mat-error>
        <mat-error *ngIf="form.get('name').touched && form.get('name').hasError('minlength')">
          Tax name must be at least <strong>2</strong> characters long
        </mat-error>
        <mat-error *ngIf="form.get('name').touched && form.get('name').hasError('maxlength')">
          Tax name must be at most <strong>50</strong> characters long
        </mat-error>
      </mat-form-field>
    </div>
    <div class="col-sm-3">
      <mat-form-field class="mat-block">
        <mat-label><span [innerHtml]="form.get('type').value | amountPlaceholder: currencySymbol"></span></mat-label>
        <input type="number" min="0" formControlName="amount" matInput decimal="4" required />
        <mat-error *ngIf="form.get('amount').touched && form.get('amount').hasError('required')">
          Amount is <strong>required</strong>
        </mat-error>
      </mat-form-field>
    </div>
    <div class="col-sm-4">
      <mat-form-field [floatLabel]="'never'" class="mat-block">
        <mat-select formControlName="type" placeholder="Type">
          <mat-option value="percent">Percent</mat-option>
          <mat-option value="flat">Flat</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </form>

  <div class="row">
    <div class="col-sm-12">
      <p>Newly created tax is added to your account. Tax will appear as an option on invoice items.</p>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button (click)="close()" type="button" class="btn btn-outline btn-default-outline text-uppercase">
    <i class="fal fa-times"></i> cancel
  </button>
  <button (click)="onSave(form)" type="button" class="btn btn-success text-uppercase create-btn">
    <i class="fal fa-plus"></i> create
  </button>
</div>
